<script setup lang="ts">
import type { HTMLAttributes } from "vue";
import { ChevronDownIcon, WrenchIcon } from "lucide-vue-next";
import { CollapsibleTrigger } from "@/components/ui/collapsible";
import { cn } from "@/lib/utils";
import type { ToolUiState } from "../../../types/chat";
import ToolStatusBadge from "./ToolStatusBadge.vue";

const props = defineProps<{
  title?: string;
  state: ToolUiState | string;
  class?: HTMLAttributes["class"];
}>();
</script>

<template>
  <CollapsibleTrigger
    :class="cn('group flex w-full items-center justify-between gap-4 p-3', props.class)"
    v-bind="$attrs"
  >
    <div class="flex min-w-0 items-center gap-2">
      <WrenchIcon class="size-4 shrink-0 text-muted-foreground" />
      <span class="truncate text-sm font-medium">{{ props.title }}</span>
      <ToolStatusBadge :state="props.state" />
    </div>
    <ChevronDownIcon
      class="size-4 shrink-0 text-muted-foreground transition-transform group-data-[state=open]:rotate-180"
    />
  </CollapsibleTrigger>
</template>
